import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import { connect } from 'react-redux';
import {
    Container,
    Title,
    Button,
    Div,
    SubTitle,
    TitleWrap,
    Text,
    SubTitleWrap
} from './ReportVideoPopup.style';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import i18n from '../../i18n';
import { withStyles } from '@material-ui/core/styles';

const styles = {
    root : {
        padding : "0"
    },
    icon : {
        padding: "8px 12px"
    }
}
class ReportVideoPopup extends Component {
    renderLang = () => {
        const { lang } = this.props;
        if (lang === "ko") {
            return (
                <Text fontSize={"14px"}>
                    허위 신고일 경우, 신고자의 서비스 활동이<br />
                    제한 될 수 있으니 신중하게 신고해주세요.
                </Text>
            )
        }
        else if (lang === "jp") {
            return (
                <Text fontSize={"14px"}>
                    偽りの通報をされた場合、通報者のサービス及び利用が<br />
                    制限される為、慎重に通報してください。
                </Text>
            )
        }
        else {
            return (
                <Text fontSize={"14px"}>
                    If you make false report, your account can be banned<br />
                    Please be aware to report the issue
                </Text>
            )
        }
    }
    render() {
        const { lang, reportValue, onChange, open, onClose, sendReport ,classes } = this.props
        return (
            <Dialog open={open} onClose={onClose} maxWidth={"md"}>
                <Container lang={lang}>
                    <TitleWrap>
                        <Title>{i18n.t("web.gallery.vdieo.report")}</Title>
                        {this.renderLang()}
                    </TitleWrap>
                   
                 
                    <Div padding ={"20px 70px 20px 28px"} direction>
                        <SubTitleWrap>
                        <SubTitle>{i18n.t("web.gallery.reportReason")}</SubTitle>
                        <Text color = {"#adadad"} fontSize = {"12px"}>{i18n.t("web.gallery.reportSelect")}</Text>
                        </SubTitleWrap>
                        <FormControl component="fieldset">
                            <RadioGroup classes={{root : classes.root}} aria-label="report" name="report" value={reportValue} onChange={onChange}>
                                <FormControlLabel value="a" control={<Radio classes={{root : classes.icon}} />} label={i18n.t("web.gallery.video.report.a")} /> 
                                <FormControlLabel value="b" control={<Radio classes={{root : classes.icon}} />} label={i18n.t("web.gallery.video.report.b")} />
                                <FormControlLabel value="c" control={<Radio classes={{root : classes.icon}} />} label={i18n.t("web.gallery.video.report.c")} />
                                {/* <FormControlLabel value="d" control={<Radio />} label={i18n.t("web.gallery.video.report.d")} /> */}
                                <FormControlLabel value="e" control={<Radio classes={{root : classes.icon}} />} label={i18n.t("web.gallery.video.report.e")} />
                                {/* <FormControlLabel value="f" control={<Radio />} label={i18n.t("web.gallery.video.report.f")} /> */}
                                <FormControlLabel value="g" control={<Radio classes={{root : classes.icon}} />} label={i18n.t("web.gallery.video.report.g")} />
                                <FormControlLabel value="h" control={<Radio classes={{root : classes.icon}} />} label={i18n.t("web.gallery.video.report.h")} />
                            </RadioGroup>
                        </FormControl>
                    </Div>
                    <Div borderTop  justify={"flex-end"} padding ={"20px 28px"} margin = {" 0 0 0 auto"}>
                        <Button onClick={onClose} margin={"0 5px 0 0"} cancel>{i18n.t("global.cancel")}</Button>
                        <Button onClick={sendReport} margin={"0 0 0 5px"}>{i18n.t("web.gallery.report")}</Button>
                    </Div>

                </Container>
            </Dialog>
        );
    }
}


const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default connect(mapStateToProps,null)(withStyles(styles)(ReportVideoPopup));